<template>
    <div class="back">
        <div class="newCenter">
            <div class="left">
                <div>
                    长三角农田土壤污染分布与健康风险评估系统
                </div>
                <img src="@/imgs/loginnew2.png" alt="">
            </div>
            <div class="right">
                <p class="ssdw">欢迎登录</p>
                <div class="inputbox">
                    <i class="el-icon-user" ></i>
                    <input v-model="username" type="text" placeholder="用户名">
                </div>
                <div class="inputbox">
                    <i class="el-icon-lock"></i>
                    <input v-model="password" type="password" placeholder="密码">
                </div>
                <el-button class="logbtn"  @click="login">
                    登录
                </el-button>
                <p class="ssdw ssdw1">
                    所属单位：浙江工商大学
                </p>
            </div>
        </div>
        <!-- <h1 class="name">长三角农田土壤污染分布与健康风险评估系统</h1>
        <div class="center">
            <h1>用户登录</h1>
            <el-input v-model="username" placeholder="请输入用户名"></el-input>
            <el-input v-model="password" placeholder="请输入密码" autocomplete="off" type="password"></el-input>

            <button @click="login">登录</button>
        </div> -->
    </div>
</template>
<script>
import apiService from '@/request/api'
export default {
    data() {
        return {
            username: "",
            password: ""
        }
    },
    methods: {
        async login() {
            // this.$router.push('/HomeView')
            // console.log(this.username, this.password)
            // this.$Cookie.set("token", "Bearer11111")
            if(this.username == undefined){
                this.username = ""
                
            }
            if (this.username.trim() == "" ) {
                this.$message.error('请输入用户名');
            } else if (this.password.trim() == "") {
                this.$message.error('请输入密码');
            } else {
                const data ={
                    username: this.username,
                    password: this.password
                }
                const res =  await apiService.login(data)
                if(res.status == 200){
                        this.$message({
                        message: '登录成功',
                        type: 'success'
                    });
                this.$Cookie.set("username", this.username)
                this.$Cookie.set("token", "Bearer "+res.data.token)
                this.$router.push('/HomeView')
                }else{
                    this.$message.error('登录失败');
                }
               
          

            }
        },
        handleWatchEnter(e) {
            console.log(e.keyCode)
            if (e.keyCode == "13") {
                this.login()
            }
        }
    },
    mounted() {
    console.log(typeof([1]))
        this.username = ""
        this.password = ""
        this.username = this.$Cookie.get("username")
        document.addEventListener('keydown', this.handleWatchEnter);
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleWatchEnter)
    }
}
</script>
<style lang="scss" >
.back {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background-image: url(../imgs/0-bg.png);
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-repeat: no-repeat;
    .name{
        margin-bottom: 100px;
    }

}

.center {
    width: 300px;
    height: 350px;
    background-color: rgba(255, 255, 255, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 8px;
}

h1 {
    margin-top: 10px;
    color: #fff;
    font-size: 30px;
    font-weight: normal;
}

.center {
    .el-input {
        background-color: rgba(0, 0, 0, 0);

        height: 42px;
        margin-top: 40px;
        width: 250px !important;
        border-color: #fff;
    }

    button {
        width: 250px;
        height: 40px;
        cursor: pointer;
        margin-top: 50px;
    }
}
.newCenter{
    display: flex;
    .left{
        width: 500px;
        height: 360px;
        // background-image: url(../imgs/loginnew.png);
        background-color: #5688c7;
        background-size: cover;
        background-size: 500px 360px;
        font-size: 22px;
        font-weight: 700;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        div{
            margin-bottom: 8px;
        }
    }
    .right{
        box-sizing: border-box;
        background-color: #fff;
        padding: 20px 40px 20px 20px;
        width: 500px;
        height: 360px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .inputbox{
            border: 1px solid gray;
            height: 36px;
            display: flex;
            align-items: center;
            padding-left: 4px;
            i{
                font-size: 30px;
            }
            input{
                flex: 1;
                height: 100%;
                padding-left: 6px;
                outline: none;
                border: none;
            }
        }
        .ssdw{
            font-size: 18px;
            font-weight: 600;
        }
        .ssdw1{
            text-align: center;
            font-size: 20px;
        }
        .logbtn{
            background-color: #415db0;
            color: #fff;
            font-size: 18px;
        }
    }
}
div{
    box-sizing: border-box;
}
</style>